import React from 'react'
import ReactDOM from 'react-dom/client'

import './assets/styles/application.scss'
import reportWebVitals from './reportWebVitals'
import { RouterProvider } from 'react-router-dom'
import routers from './routers/router'
import { ConfigProvider, App } from 'antd'
import store from './store/store'
import { Provider } from 'react-redux'
import zhCN from 'antd/locale/zh_CN'

const rootElement = document.getElementById('root')
if (rootElement) {
  rootElement.setAttribute('translate', 'no')
  rootElement.classList.add('notranslate')
}

const root = ReactDOM.createRoot(rootElement)
root.render(
  // <React.StrictMode>
  <ConfigProvider componentSize="normal" locale={ zhCN }>
    <App>
      <Provider store={ store }>
        <RouterProvider router={ routers }/>
      </Provider>
    </App>
  </ConfigProvider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
